module.exports = __webpack_public_path__ + "img/managed.f62a175.svg";